/**
 * Permission module names used for PermissionGate and route checks.
 * Must match the keys returned by GET /users/me (data.roleId.permissions).
 * Backend uses company_members:add, company_members:update, company_members:remove.
 */
export const COMPANY_MEMBERS_MODULE = 'company_members' as const
